import styled from 'styled-components';

import { Button } from '../../../../../../components/Toolkit/Button/Button';

const SelectButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

const TextContainer = styled.span`
  display: flex;
  overflow: hidden;
  min-width: 0;
  flex: 1;
  margin-right: ${({ theme }) => theme.spacing.M16};
`;

const MainText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const CountContainer = styled.span`
  flex-shrink: 0;
  margin-left: ${({ theme }) => theme.spacing.S2};
  white-space: nowrap;
`;

const CloseIconContainer = styled.div`
  flex-shrink: 0;
`;

export {
  SelectButton,
  TextContainer,
  MainText,
  CountContainer,
  CloseIconContainer,
};
